export function handleAcceptCookies() {
  window.localStorage.setItem('acceptedCookies', 'Y');
  return 'Yes';
}
